import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  Divider,
  CircularProgress,
  Grid
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import FinalBillPreviewModal from "./FinalBillPreviewModal";

const FinalBillSection = ({
  colors,
  hasFinalBill,
  invoiceId,
  finalBillSummary, 
  hotelProfile,
  // Hook Data
  openPreview,
  loading,
  previewData,
  error,
  onPreview,
  onClosePreview,
}) => {
  return (
    <>
      <Divider sx={{ my: 4 }} />

      {/* Section Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
          <Typography variant="h5" fontWeight="bold">
            Final Bill
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {hasFinalBill
              ? `Invoice generated: #${invoiceId}`
              : "Generate a read-only preview before finalizing."}
          </Typography>
        </Box>

        <Button
          variant={hasFinalBill ? "contained" : "outlined"}
          color="info"
          startIcon={loading ? <CircularProgress size={16} /> : <Visibility />}
          onClick={onPreview}
          disabled={loading}
        >
          {hasFinalBill ? "View Final Bill" : "Preview Final Bill"}
        </Button>
      </Stack>

      {/* Summary / Placeholder Area */}
      <Paper sx={{ p: 2, backgroundColor: colors.primary[500] }}>
         <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography color={colors.grey[100]}>Total Amount</Typography>
                    <Typography fontWeight="bold">₹ {finalBillSummary?.total || 0}</Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between" mt={1}>
                    <Typography color={colors.grey[100]}>Paid</Typography>
                    <Typography color="green">₹ {finalBillSummary?.paid || 0}</Typography>
                </Stack>
                <Divider sx={{ my: 1 }}/>
                <Stack direction="row" justifyContent="space-between">
                    <Typography fontWeight="bold">Balance Pending</Typography>
                    <Typography fontWeight="bold" color="error">₹ {finalBillSummary?.pending || 0}</Typography>
                </Stack>
            </Grid>
         </Grid>
      </Paper>

      {/* Preview Modal - Strictly Read Only */}
      <FinalBillPreviewModal
        open={openPreview}
        onClose={onClosePreview}
        loading={loading}
        error={error}
        invoiceData={previewData}
        hotelProfile={hotelProfile}
      />
    </>
  );
};

export default FinalBillSection;